import { GAME_EVENTS } from 'js/app/components/main/Games/constants';

export const EVENTS_DATA = [
    ['auth:logout', 'logged_out'],
    ['auth:login', 'logged_in'],
    ['auth:login:failed', 'logged_in_fail', ['errorCode', 'errorText', 'playerMessage']],
    ['forgotPassword:fail', 'forgot_password_fail'],
    ['forgotPassword:success', 'forgot_password_success'],
    ['user:updatePaymentStatistics', 'user_payment_statistics_updated'],
    ['bannerPosition', 'Promo_Positions', ['page', 'position', 'link', 'action']],
    ['promoPosition', 'Promo_Positions', ['page', 'position', 'title', 'link', 'action']],
    [GAME_EVENTS.GAME_PORTLET_CATEGORY_CHANGE, 'game_portlet_category_change', ['feedName', 'categoryName']],
    [GAME_EVENTS.GAME_LAUNCH, 'game_launch', ['gameCode', 'gameType', 'feedName', 'gameName']],
    [GAME_EVENTS.GAME_POSITION, 'Game Positions', ['game', 'gameCode', 'categoryName', 'page', 'position']],
    [GAME_EVENTS.GAME_FAVORITES_CHANGE, 'game_favorites_handler_event', ['gameCode', 'method']],
    [GAME_EVENTS.GAME_PORTLET_SORT, 'game_portlet_sort', ['feedName', 'currentSortType', 'newSortType']],
    [GAME_EVENTS.GAME_PORTLET_SEARCH, 'game_portlet_search', ['searchString']],
    [GAME_EVENTS.GAME_PORTLET_VIEW, 'game_portlet_view', ['feedName', 'viewType']],
    [GAME_EVENTS.GAME_PORTLET_DISPLAY, 'game_portlet_display', ['portletId', 'feedName']],
    ['id_verification:passed', 'idv_passed']
];

export const DEFAULT_ANALITICS_FEED_NAMES = {
    recently: 'Recently',
    search: 'Search result',
    unknown: 'Unknown'
};
